import axios from "axios";
import authHeader from "./auth-header";
import server from "../config/server.config";

const API_URL = server.host + (server.port ? ":" + server.port : "") + "/api/";

const getPublicContent = () => {
  console.log(server);
  console.log(API_URL + "users/all");
  const a = axios.get(API_URL + "users/all");
  // console.log(a);
  return a;
};

const getUserBoard = () => {
  return axios.get(API_URL + "user", { headers: authHeader() });
};

const getModeratorBoard = () => {
  return axios.get(API_URL + "mod", { headers: authHeader() });
};

const getAdminBoard = () => {
  return axios.get(API_URL + "admin", { headers: authHeader() });
};

const getUserToDo = () => {
  return axios.get(API_URL + "user/todos", {
    timeout: 1000,
    headers: authHeader(),
  });
};

const postUserToDo = (user, todo) => {
  const userid = user.id;
  const key = 1;
  const data = {
      id: todo.id,
      userid: userid,
      key: key,
      tasks: todo.tasks,
    };
  // console.log(todo);
  return axios.post(API_URL + "user/todos", data, {
    // `method` is the request method to be used when making the request
    method: "post", // default "get"
    headers: authHeader(),
    // `data` is the data to be sent as the request body
    // Only applicable for request methods 'PUT', 'POST', 'DELETE , and 'PATCH'
    // When no `transformRequest` is set, must be of one of the following types:
    // - string, plain object, ArrayBuffer, ArrayBufferView, URLSearchParams
    // - Browser only: FormData, File, Blob
    // - Node only: Stream, Buffer
    // syntax alternative to send data into the body
    // method post
    // only the value is sent, not the key
    // data: "Country=Brasil&City=Belo Horizonte",

    // `timeout` specifies the number of milliseconds before the request times out.
    // If the request takes longer than `timeout`, the request will be aborted.
    timeout: 1000, // default is `0` (no timeout)
  });
};

const getUserNotes = () => {
  return axios.get(API_URL + "user/notes", {
    timeout: 1000,
    headers: authHeader(),
  });
};

const postUserNotes = (user, notes) => {
  const data = {
    userid: user.id,
    notes: notes,
  };
  // console.log(notes);
  return axios.post(API_URL + "user/notes", data, {
    // `method` is the request method to be used when making the request
    method: "post", // default "get"
    headers: authHeader(),
    // `data` is the data to be sent as the request body
    // Only applicable for request methods 'PUT', 'POST', 'DELETE , and 'PATCH'
    // When no `transformRequest` is set, must be of one of the following types:
    // - string, plain object, ArrayBuffer, ArrayBufferView, URLSearchParams
    // - Browser only: FormData, File, Blob
    // - Node only: Stream, Buffer
    // syntax alternative to send data into the body
    // method post
    // only the value is sent, not the key
    // data: "Country=Brasil&City=Belo Horizonte",

    // `timeout` specifies the number of milliseconds before the request times out.
    // If the request takes longer than `timeout`, the request will be aborted.
    timeout: 1000, // default is `0` (no timeout)
  });
};

const getUserMenus = () => {
  return axios.get(API_URL + "user/menus", {
    timeout: 1000,
    headers: authHeader(),
  });
};

const postUserMenus = (user, menus) => {
  const data = {
    userid: user.id,
    menus: menus,
  };
  // console.log(menus);
  return axios.post(API_URL + "user/menus", data, {
    // `method` is the request method to be used when making the request
    method: "post", // default "get"
    headers: authHeader(),
    // `data` is the data to be sent as the request body
    // Only applicable for request methods 'PUT', 'POST', 'DELETE , and 'PATCH'
    // When no `transformRequest` is set, must be of one of the following types:
    // - string, plain object, ArrayBuffer, ArrayBufferView, URLSearchParams
    // - Browser only: FormData, File, Blob
    // - Node only: Stream, Buffer
    // syntax alternative to send data into the body
    // method post
    // only the value is sent, not the key
    // data: "Country=Brasil&City=Belo Horizonte",

    // `timeout` specifies the number of milliseconds before the request times out.
    // If the request takes longer than `timeout`, the request will be aborted.
    timeout: 1000, // default is `0` (no timeout)
  });
};

const getUserIngredients = () => {
  return axios.get(API_URL + "user/ingredients", {
    timeout: 1000,
    headers: authHeader(),
  });
};

const postUserIngredients = (user, ingredients) => {
  const data = {
    userid: user.id,
    ingredients: ingredients,
  };
  // console.log(menus);
  return axios.post(API_URL + "user/ingredients", data, {
    // `method` is the request method to be used when making the request
    method: "post", // default "get"
    headers: authHeader(),
    // `data` is the data to be sent as the request body
    // Only applicable for request methods 'PUT', 'POST', 'DELETE , and 'PATCH'
    // When no `transformRequest` is set, must be of one of the following types:
    // - string, plain object, ArrayBuffer, ArrayBufferView, URLSearchParams
    // - Browser only: FormData, File, Blob
    // - Node only: Stream, Buffer
    // syntax alternative to send data into the body
    // method post
    // only the value is sent, not the key
    // data: "Country=Brasil&City=Belo Horizonte",

    // `timeout` specifies the number of milliseconds before the request times out.
    // If the request takes longer than `timeout`, the request will be aborted.
    timeout: 1000, // default is `0` (no timeout)
  });
};


const getUserRecipes = () => {
  return axios.get(API_URL + "recipes", {
    timeout: 1000,
    headers: authHeader(),
  });
};

const postUserFilteredRecipes = (user, filterVector) => {
  // return axios.get(API_URL + "recipes", {
  //   timeout: 1000,
  //   headers: authHeader(),
  // });
  const data = {
    userid: user.id,
    filterVector: filterVector,
  };
  // console.log(data);
  return axios.post(API_URL + "recipes/filter", data, {
    // `method` is the request method to be used when making the request
    method: "post", // default "get"
    headers: authHeader(),
    timeout: 1000, // default is `0` (no timeout)
  });
};



const postUserRecipes = (user, recipes) => {
  const data = {
    userid: user.id,
    recipes: recipes,
  };
  // console.log(menus);
  return axios.post(API_URL + "recipes", data, {
    // `method` is the request method to be used when making the request
    method: "post", // default "get"
    headers: authHeader(),
    timeout: 1000, // default is `0` (no timeout)
  });
};




const userServices = {
  getPublicContent,
  getUserBoard,
  getModeratorBoard,
  getAdminBoard,
  getUserToDo,
  postUserToDo,
  getUserNotes,
  postUserNotes,
  getUserMenus,
  postUserMenus,
  getUserIngredients,
  postUserIngredients,
  getUserRecipes,
  postUserFilteredRecipes,
  postUserRecipes,
};

export default userServices;
